import { isQueryStatementCompleted } from "pages/DevelopWorkspace/contexts/DocumentsContext/helpers/getQueryStatementState";
import {
  QueryStatement,
  QueryStatementStatus,
} from "pages/DevelopWorkspace/workspace.types";

export const shouldIgnoreQSUpdate = (
  current: QueryStatement,
  nextStatus: QueryStatementStatus
) => {
  // The query statement is completed, but getting progress updates
  // In this case, we want to ignore the changes.
  return (
    isQueryStatementCompleted(current) &&
    nextStatus === QueryStatementStatus.running
  );
};
